import { onView, onMount, onDestroy } from "@/modules/_";
import gsap from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const gridCards = element.querySelectorAll(".home_product_grid_card");

  gsap.set(gridCards, {
    opacity: 0,
  });

  const observer = onView(element, {
    root: null,
    rootMargin: "0px",
    threshold: 0,
    autoStart: false,
    once: true,
    callback: ({ isIn }) => {
      if (isIn) {
        gsap.to(gridCards, {
          opacity: 1,
          duration: 1.2,
          ease: "smooth",
          stagger: (_, target) => {
            const index = Number(target.dataset.index);
            return index * 0.3;
          },
        });
      }
    },
  });

  onMount(() => {
    observer.start();
  });

  onDestroy(() => {
    observer.destroy();
  });
}
